/**
 * Visor de fotos de adjuntos con botones para rotarlas.
 *
 * Muchas boletas se fotografían de lado; el navegador muestra la imagen tal
 * cual y no hay forma de enderezarla. La rotación es solo visual (CSS): no se
 * modifica el archivo guardado.
 *
 * La pestaña parte vacía (sin los estilos ni el JS del admin), así que estilos
 * y script van en línea. El script se inyecta en la propia pestaña para que los
 * botones sigan funcionando aunque se cierre el admin que la abrió.
 */

const STYLES = `
  * { box-sizing: border-box; }
  html, body { height: 100%; margin: 0; }
  body {
    display: flex; flex-direction: column;
    background: #111827;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  .toolbar {
    display: flex; justify-content: center; gap: 8px;
    padding: 10px 16px;
    background: #1F2937;
  }
  .toolbar button {
    padding: 8px 14px;
    border: 1px solid #374151; border-radius: 8px;
    background: #FFFFFF; color: #104B94;
    font: inherit; font-size: 14px; font-weight: 600;
    cursor: pointer;
  }
  .toolbar button:hover { background: #E8F0FB; }
  .stage {
    flex: 1; min-height: 0;
    display: flex; align-items: center; justify-content: center;
    overflow: hidden;
  }
  .stage img {
    max-width: 100%; max-height: 100%;
    transition: transform 0.2s ease;
  }
  .stage img.loading { display: none; }
  .status { color: #D1D5DB; font-size: 14px; text-align: center; }
  .status[hidden] { display: none; }
  .spinner {
    width: 40px; height: 40px; margin: 0 auto 14px;
    border: 4px solid #374151;
    border-top-color: #FFFFFF;
    border-radius: 50%;
    animation: spin 0.9s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }
  @media (prefers-reduced-motion: reduce) {
    .spinner { animation-duration: 2.4s; }
  }
  /* De lado, el ancho de la foto ocupa el alto de la pantalla y viceversa. */
  .stage img.sideways { max-width: calc(100vh - 56px); max-height: 100vw; }
`;

const MARKUP = `
  <div class="toolbar">
    <button type="button" id="rotate-left" title="Rotar a la izquierda">&#x21BA; Izquierda</button>
    <button type="button" id="rotate-right" title="Rotar a la derecha">Derecha &#x21BB;</button>
  </div>
  <div class="stage">
    <div class="status" id="image-status" role="status" aria-live="polite">
      <div class="spinner" id="image-spinner" aria-hidden="true"></div>
      <span id="image-status-text">Cargando la foto…</span>
    </div>
    <img id="attachment-image" class="loading" alt="Adjunto">
  </div>
`;

const SCRIPT = `
  (function () {
    var image = document.getElementById('attachment-image');
    var status = document.getElementById('image-status');
    var degrees = 0;
    function showImage() {
      status.hidden = true;
      image.classList.remove('loading');
    }
    function showError() {
      document.getElementById('image-spinner').hidden = true;
      document.getElementById('image-status-text').textContent = 'No se pudo cargar la foto.';
    }
    if (image.complete && image.naturalWidth) {
      showImage();
    } else {
      image.addEventListener('load', showImage);
      image.addEventListener('error', showError);
    }
    function rotate(step) {
      degrees = (degrees + step + 360) % 360;
      image.style.transform = 'rotate(' + degrees + 'deg)';
      image.classList.toggle('sideways', degrees % 180 !== 0);
    }
    document.getElementById('rotate-left').addEventListener('click', function () { rotate(-90); });
    document.getElementById('rotate-right').addEventListener('click', function () { rotate(90); });
  })();
`;

/**
 * Reemplaza el contenido de la pestaña por el visor de la foto.
 *
 * @param {Window} tab - Pestaña abierta con window.open('').
 * @param {string} src - URL de la imagen (firmada o blob local).
 */
export function renderImageViewerPage(tab, src) {
  const doc = tab.document;
  doc.title = 'Adjunto';
  doc.head.innerHTML = '';
  const style = doc.createElement('style');
  style.textContent = STYLES;
  doc.head.appendChild(style);
  // Solo contenido estático: la URL entra por la propiedad, no por el HTML.
  doc.body.innerHTML = MARKUP;
  doc.getElementById('attachment-image').src = src;
  const script = doc.createElement('script');
  script.textContent = SCRIPT;
  doc.body.appendChild(script);
}
